import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["burger", "navbar", "panel", "overlay", "content", "mobilePanel", "mobileContent", "desktopNavbar"];

  initialize() {
    this.isOpen = false;
  }

  toggle(event) {
    event.preventDefault();
    this.isOpen = !this.isOpen;
    this.updateDom();
  }

  close() {
    this.isOpen = false;
    this.updateDom();
  }

  isMobile() {
    return window.innerWidth < 768;
  }

  updateDom() {
    this.burgerTargets.forEach((burger) => burger.classList.toggle("active", this.isOpen));

    if (this.isMobile()) {
      this.updateMobileDom();
    } else {
      this.updateDesktopDom();
    }
  }

  updateMobileDom() {
    if (this.hasNavbarTarget) {
      this.navbarTarget.classList.toggle("bg-primary-600", this.isOpen);
      this.navbarTarget.classList.toggle("bg-primary-500", !this.isOpen);
    }

    if (this.hasMobilePanelTarget) {
      if (this.isOpen) {
        this.mobilePanelTarget.style.height = "calc(100dvh - 5rem)";
      } else {
        this.mobilePanelTarget.style.height = "0";
      }
    }

    if (this.hasMobileContentTarget) {
      this.mobileContentTarget.classList.toggle("in", this.isOpen);
    }

    this.overlayTarget.classList.toggle("opacity-90", this.isOpen);
    this.overlayTarget.classList.toggle("pointer-events-auto", this.isOpen);
    this.overlayTarget.classList.toggle("opacity-0", !this.isOpen);
    this.overlayTarget.classList.toggle("pointer-events-none", !this.isOpen);

    document.body.classList.toggle("overflow-hidden", this.isOpen);
  }

  updateDesktopDom() {
    if (this.hasDesktopNavbarTarget) {
      this.desktopNavbarTarget.classList.toggle("bg-primary-600", this.isOpen);
      this.desktopNavbarTarget.classList.toggle("bg-primary-500", !this.isOpen);
    }

    if (this.hasPanelTarget) {
      this.panelTarget.classList.toggle("translate-x-0", this.isOpen);
      this.panelTarget.classList.toggle("-translate-x-full", !this.isOpen);
    }

    const desktopContent = this.contentTargets[1];
    if (desktopContent) {
      desktopContent.classList.toggle("in", this.isOpen);
    }

    this.overlayTarget.classList.toggle("opacity-90", this.isOpen);
    this.overlayTarget.classList.toggle("pointer-events-auto", this.isOpen);
    this.overlayTarget.classList.toggle("opacity-0", !this.isOpen);
    this.overlayTarget.classList.toggle("pointer-events-none", !this.isOpen);
  }
}
